import React from "react";
// import Common Banner
import CommonBanner from "../component/Common/CommonBanner";
// import AboutArea
import AboutArea from "../component/About/AboutArea";
// import DiscountArea
import DiscountArea from "../component/About/DiscountArea";
// import AboutServices
import AboutServices from "../component/About/Services";
// import Consultation
import Consultation from "../component/About/Consultation";
// import Counter
import Counter from "../component/About/Counter";
// import CustomerReview
import CustomerReview from "../component/About/CustomerReview";
import CorporateTravelText from "../component/Services/corporateTravel";
import BookYourTravel from "../component/BookYourTravel";
import TravelConsultingText from "../component/Services/travelConsulting";
import ReligiousTravelText from "../component/Services/religiousTravel";
import { ImageConstants } from "../assets/img/ImageConstants";

const ReligiousTravel = () => {
  return (
    <>
      {/* <CommonBanner heading="Religious Travel" pagination="Religious Travel " /> */}
      <CommonBanner
        heading="Religious Travel"
        img={ImageConstants.religioustravelheadbanner}
        pagination="Religious Travel"
      />
      <ReligiousTravelText/>
      <DiscountArea
        smallImg={ImageConstants.relegioustravelsmalll}
        largeImg={ImageConstants.relegioustravellarge}
      />
      <BookYourTravel />
    </>
  );
};

export default ReligiousTravel;
